import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalComponent } from 'src/app/global/global.component';
import { SeoService } from 'src/app/service/seo.service';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {
  hostName = GlobalComponent.hostName;

  constructor(private SEOService:SeoService,private router :Router) { }

  ngOnInit(){

  window.scroll(0,0);

  this.SEOService.updateCanonicalUrl(this.hostName + '/testimonials');


  }
  signup()
  {
    this.router.navigate(['/login/signup']);

  }

}
